import { t } from 'i18next';
import { formatDateTime, transformDateToInputValue } from '@pocapan/shared/utils/DateUtil';
import type { components } from '@pocapan/shared/types/schema';

type ApiV1Payment = components['schemas']['ApiV1Payment'];

interface BettiePurchaseHistoryItemProps {
  item: ApiV1Payment;
}

const BettiePurchaseHistoryItem = ({ item }: BettiePurchaseHistoryItemProps) => {
  const expiryYmd = transformDateToInputValue(item.expiryDate);
  const expiryLabel = expiryYmd ? expiryYmd.replace(/-/g, '.') : '';

  return (
    <div className="relative w-full px-[20px] py-[16px] bg-background-elevated rounded-[20px] shadow-[0_0_3px_0_rgba(0,0,0,0.06),_0_0_12px_0_rgba(0,0,0,0.08)]">
      <div className="w-full flex flex-col gap-[15px] items-start justify-between">
        <p className="text-[12px] text-text-main-lv2 leading-[14px] truncate">
          {formatDateTime(item.approvedAt, 'PPP')}
        </p>
        <div className="flex justify-between items-center w-full">
          <div className="flex flex-col items-start gap-[6px] min-w-0">
            <p className="text-[15px] font-semibold text-text-main-lv2 leading-[18px] truncate">
              {item.productName}
            </p>
            {expiryLabel ? (
              <p className="text-[13px] text-text-main-lv4 leading-[16px] truncate">
                {t('BettiePurchaseHistory.expirationDate', { date: expiryLabel })}
              </p>
            ) : null}
          </div>
          <p className="text-[16px] font-semibold text-text-primary leading-[19px]">
            {Number(item.amount).toLocaleString('ko-KR')}원
          </p>
        </div>
      </div>
    </div>
  );
};

export default BettiePurchaseHistoryItem;
